<template>
  <div class="student-data__component" v-if="digitalExam">
    <div class="student-view__panel-content">
      <div class="panel__row">
        <student-info label="Curso" :value="paymentPlan.course" />
        <student-info label="Status do vestibular" :value="digitalExam.status" />
        <student-info label="Status da redação" :value="essay.status" />
      </div>
      <div class="panel__row">
        <student-info label="Tema da redação" :value="essay.theme" />
        <student-info label="Início da redação" :value="parseDate(essay.startedAt)" />
        <student-info label="Término da redação" :value="parseDate(essay.finishedAt)" />
      </div>
    </div>
  </div>
</template>
<script>
import StudentInfo from 'components/StudentInfo';
import moment from 'moment';

export default {
  components: {
    StudentInfo,
  },
  props: {
    paymentPlan: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    digitalExam() {
      return this.paymentPlan.digitalExam;
    },
    essay() {
      return this.digitalExam.essay || {};
    },
  },
  methods: {
    parseDate(date) {
      if (!date) {
        return null;
      }

      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
</script>
